import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ApiserviceService {
  baseUrl: any = '';
  mediaUrl: any = '';
  baseApiUrl = "https://kmueem.com/sistem/index.php/urunler2/upload"
  baseApiUrl2 = "https://kmueem.com/sistem/index.php/haber/upload"

  constructor(private http:HttpClient) { 
    this.baseUrl = environment.baseURL;
    this.mediaUrl = environment.mediaURL;
  }

  JSON_to_URLEncoded(element, key?, list?) {
    let new_list = list || [];
    if (typeof element === 'object') {
      for (let idx in element) {
        this.JSON_to_URLEncoded(
          element[idx],
          key ? key + '[' + idx + ']' : idx,
          new_list
        );
      }
    } else {
      new_list.push(key + '=' + encodeURIComponent(element));
    }
    return new_list.join('&');
  }

  public post(url, body): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const header = {
        headers: new HttpHeaders()
         .set('Content-Type', 'application/x-www-form-urlencoded')
      };
      const param = this.JSON_to_URLEncoded(body);
     // console.log(body);
   //   console.log(param, 'burası');
      this.http.post(this.baseUrl + url, param, header).subscribe((data) => {
        resolve(data);
      }, error => {
        resolve(error);
      });
       return this.http.post(this.baseUrl + url, param, header);
    });
  }
 






  // API url

  
    // Returns an observable
    upload(file,urun_kimlik):Observable<any> {

      // Create form data
      const formData = new FormData(); 
      
      // Store form name as "file" with file data
      formData.append("uploadedFiles", file, file.name);
      formData.append("urunid", urun_kimlik);

      
      // Make http post request over api
      // with formData as req
      return this.http.post(this.baseApiUrl, formData)
  }


  haberupload(files: File[], userid: any, haberid: any, metin: any): Observable<any> {
  const formData = new FormData();

  // 🔹 Birden çok dosya ekle
  for (let i = 0; i < files.length; i++) {
    formData.append("uploadedFiles[]", files[i], files[i].name);
  }

  formData.append("userid", userid);
  formData.append("haberid", haberid);
  formData.append("metin", metin);

  return this.http.post(this.baseApiUrl2, formData);
}





  productservis(){
    return [
    {
      id: 1,
      name: "100",
      
    },
    {
      id: 2,
      name: "200",
    },
    {
      id: 3,
      name: "300",
    },
    {
      id: 4,
      name: "400",
    },
    {
      id: 5,
      name: "500",
    },

  ]

  }



  public get(url): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const header = {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded')
      };
      this.http.get(this.baseUrl + url, header).subscribe((data) => {
        resolve(data);
      }, error => {
        resolve(error);
      });
    });
  }
}
